import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, TextField } from "@mui/material";
import { TransitionProps } from "notistack";
import React from "react";
import PaymentDialogDispatch from "./model";
import PaymentDialogState from "../State/PaymentDialogState";
import '../../../../../Util/ext'

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


class PaymentDialog extends React.Component<{ isOpen: boolean, onPayClicked: (amount: number) => void, onClose: () => void }>{

    render() {
        let dispatcher: PaymentDialogDispatch = (this.props as any).dispatcher
        let state: PaymentDialogState = (this.props as any).state

        return (
            <Dialog open={this.props.isOpen} dir="rtl"

                TransitionComponent={Transition}>
                <DialogTitle>شارژ کیف پول</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        مبلغ مورد نیاز برای افزایش کیف پول را به تومان وارد کنید.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="مبلغ شارژ به تومان"
                        type="number"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                            dispatcher.text(e.target.value)
                        }}
                        helperText={state.error === undefined && state.text.length > 0 ? state.text.toWordPrice() + ' تومان' : state.error} error={state.error !== undefined}
                        
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose}>لغو</Button>
                    <Button onClick={() => {
                        if (state.text.length > 0)
                            this.props.onPayClicked(+state.text)
                        else
                            this.props.onClose()
                    }} disabled={state.error !== undefined || state.text.length === 0}>پرداخت</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default PaymentDialog